import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import './styles/main.css';
import CreatorToolBox from "./add-ons/creatorToolBox.md";
import DeveloperToolBox from "./add-ons/developerTool.md";
import SpaceContent from './add-ons/spaceAbility.md';
import LearnMoreBtn from "./add-ons/learnmore.md";
import bgImg from "./images/Summary_BgImage.jpg";
import heroVideo from "./videos/R2_Add-on.mp4";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Hero = makeShortcode("Hero");
const TextBlock = makeShortcode("TextBlock");
const WrapperComponent = makeShortcode("WrapperComponent");
const TeaserBlock = makeShortcode("TeaserBlock");
const MiniResourceCard = makeShortcode("MiniResourceCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    {/* <Hero slots="heading, text, buttons, assetsImg" customLayout variant="video" animationVideo={heroVideo} className="homeherobgImage Hero-Banner"/> */}
    <Hero slots="heading, text, buttons" variant="halfwidth" videoUrl={heroVideo} className="add-ones-hero" mdxType="Hero" />
    <h2 {...{
      "id": "build-add-ons-for-a-global-creative-community"
    }}>{`Build add-ons for a global creative community.`}</h2>
    <p><a parentName="p" {...{
        "href": "https://adobe.com/express"
      }}>{`Adobe Express`}</a>{` is an AI-first all-in-one app to easily create and share standout content. Make tools and integrations for users that extend the functionality of Adobe Express.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.adobe.com/express/add-ons/docs/guides"
        }}>{`Get started`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://new.express.adobe.com/add-ons"
        }}>{`Explore add-ons`}</a></li>
    </ul>
    <TextBlock slots="heading" className="announcement" theme="light" mdxType="TextBlock" />
    <h3 {...{
      "id": "create-powerful-solutions-for-millions-of-users"
    }}>{`Create powerful solutions for millions of users.`}</h3>
    <WrapperComponent slots="content" repeat="1" theme="light" className="wrapperforCreatorTool" mdxType="WrapperComponent" />
    <CreatorToolBox mdxType="CreatorToolBox" />
    <WrapperComponent slots="content" repeat="1" theme="light" className="learnMoreWrapper" mdxType="WrapperComponent" />
    <LearnMoreBtn mdxType="LearnMoreBtn" />
    <TextBlock slots="heading" className="announcement" theme="lightest" mdxType="TextBlock" />
    <h3 {...{
      "id": "built-by-our-community"
    }}>{`Built by our community.`}</h3>
    <SpaceContent mdxType="SpaceContent" />
    <TeaserBlock slots="buttons" className="secondaryBtn" mdxType="TeaserBlock" />
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://new.express.adobe.com/add-ons"
        }}>{`Explore more`}</a></li>
    </ul>
    <TextBlock slots="heading" className="announcement exploreCapabilities" theme="lightest" mdxType="TextBlock" />
    <h3 {...{
      "id": "explore-our-capabilities"
    }}>{`Explore our capabilities.`}</h3>
    <TextBlock slots="image, heading,text,buttons" theme="lightest" headerElementType="h2" variantsTypePrimary='secondary' variantStyleFill="outline" homeZigZag className="explore" position="right" mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1060px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "60.37735849056604%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/09bd7bef617cf672ed3fb61674c312f9/dda86/Explore_Image_1.webp 265w", "/express/add-ons/static/09bd7bef617cf672ed3fb61674c312f9/010e6/Explore_Image_1.webp 530w", "/express/add-ons/static/09bd7bef617cf672ed3fb61674c312f9/668f0/Explore_Image_1.webp 1060w", "/express/add-ons/static/09bd7bef617cf672ed3fb61674c312f9/89d57/Explore_Image_1.webp 1590w", "/express/add-ons/static/09bd7bef617cf672ed3fb61674c312f9/094b8/Explore_Image_1.webp 2120w", "/express/add-ons/static/09bd7bef617cf672ed3fb61674c312f9/f6c82/Explore_Image_1.webp 2320w"],
            "sizes": "(max-width: 1060px) 100vw, 1060px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/09bd7bef617cf672ed3fb61674c312f9/28773/Explore_Image_1.png 265w", "/express/add-ons/static/09bd7bef617cf672ed3fb61674c312f9/a0177/Explore_Image_1.png 530w", "/express/add-ons/static/09bd7bef617cf672ed3fb61674c312f9/ea60f/Explore_Image_1.png 1060w", "/express/add-ons/static/09bd7bef617cf672ed3fb61674c312f9/684d5/Explore_Image_1.png 1590w", "/express/add-ons/static/09bd7bef617cf672ed3fb61674c312f9/5e85f/Explore_Image_1.png 2120w", "/express/add-ons/static/09bd7bef617cf672ed3fb61674c312f9/d161c/Explore_Image_1.png 2320w"],
            "sizes": "(max-width: 1060px) 100vw, 1060px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/09bd7bef617cf672ed3fb61674c312f9/ea60f/Explore_Image_1.png",
            "alt": "Abstract illustration of add-ons panel in Adobe Express",
            "title": "Abstract illustration of add-ons panel in Adobe Express",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "leverage-familiar-web-technologies"
    }}>{`Leverage familiar web technologies.`}</h3>
    <p>{`Use HTML, CSS, JavaScript/TypeScript, and `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/express/add-ons/docs/guides/build/design/"
      }}>{`Spectrum`}</a>{` to build native-feeling user experiences for your add-on.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.adobe.com/express/add-ons/docs/guides/build/advanced-topics/frameworks-libraries-bundling/"
        }}>{`Learn more`}</a></li>
    </ul>
    <TextBlock slots="heading,text,image,buttons" theme="lightest" headerElementType="h2" variantsTypePrimary='secondary' variantStyleFill="outline" homeZigZag className="explore" position="left" mdxType="TextBlock" />
    <h3 {...{
      "id": "connect-to-other-services"
    }}>{`Connect to other services.`}</h3>
    <p>{`Tap into helper libraries to access secure API endpoints with OAuth 2.0.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1060px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "60.37735849056604%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/f98141221a60ced90d7135a5a7cafd97/dda86/Explore_Image_2.webp 265w", "/express/add-ons/static/f98141221a60ced90d7135a5a7cafd97/010e6/Explore_Image_2.webp 530w", "/express/add-ons/static/f98141221a60ced90d7135a5a7cafd97/668f0/Explore_Image_2.webp 1060w", "/express/add-ons/static/f98141221a60ced90d7135a5a7cafd97/9ac9d/Explore_Image_2.webp 1160w"],
            "sizes": "(max-width: 1060px) 100vw, 1060px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/f98141221a60ced90d7135a5a7cafd97/28773/Explore_Image_2.png 265w", "/express/add-ons/static/f98141221a60ced90d7135a5a7cafd97/a0177/Explore_Image_2.png 530w", "/express/add-ons/static/f98141221a60ced90d7135a5a7cafd97/ea60f/Explore_Image_2.png 1060w", "/express/add-ons/static/f98141221a60ced90d7135a5a7cafd97/9708d/Explore_Image_2.png 1160w"],
            "sizes": "(max-width: 1060px) 100vw, 1060px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/f98141221a60ced90d7135a5a7cafd97/ea60f/Explore_Image_2.png",
            "alt": "Abstract illustration of services being connected in a secure manner",
            "title": "Abstract illustration of services being connected in a secure manner",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.adobe.com/express/add-ons/docs/guides/learn/how_to/oauth2/"
        }}>{`Learn more`}</a></li>
    </ul>
    <TextBlock slots="image, heading,text,buttons" theme="lightest" headerElementType="h2" variantsTypePrimary='secondary' variantStyleFill="outline" homeZigZag className="explore" position="right" mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1060px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "60.37735849056604%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/ae3b0e1dfee5cd72433935685f40db27/dda86/Explore_Image_3.webp 265w", "/express/add-ons/static/ae3b0e1dfee5cd72433935685f40db27/010e6/Explore_Image_3.webp 530w", "/express/add-ons/static/ae3b0e1dfee5cd72433935685f40db27/668f0/Explore_Image_3.webp 1060w", "/express/add-ons/static/ae3b0e1dfee5cd72433935685f40db27/9ac9d/Explore_Image_3.webp 1160w"],
            "sizes": "(max-width: 1060px) 100vw, 1060px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/ae3b0e1dfee5cd72433935685f40db27/28773/Explore_Image_3.png 265w", "/express/add-ons/static/ae3b0e1dfee5cd72433935685f40db27/a0177/Explore_Image_3.png 530w", "/express/add-ons/static/ae3b0e1dfee5cd72433935685f40db27/ea60f/Explore_Image_3.png 1060w", "/express/add-ons/static/ae3b0e1dfee5cd72433935685f40db27/9708d/Explore_Image_3.png 1160w"],
            "sizes": "(max-width: 1060px) 100vw, 1060px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/ae3b0e1dfee5cd72433935685f40db27/ea60f/Explore_Image_3.png",
            "alt": "Illustration of dragging and dropping an asset into Adobe Express",
            "title": "Illustration of dragging and dropping an asset into Adobe Express",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "import-content-from-anywhere"
    }}>{`Import content from anywhere.`}</h3>
    <p>{`Enable users to drag and drop any image or video asset to a document.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.adobe.com/express/add-ons/docs/guides/learn/how_to/drag_and_drop/"
        }}>{`Learn more`}</a></li>
    </ul>
    <TextBlock slots="heading,text,image,buttons" theme="lightest" headerElementType="h2" variantsTypePrimary='secondary' variantStyleFill="outline" homeZigZag className="explore" position="left" mdxType="TextBlock" />
    <h3 {...{
      "id": "export-your-content-everywhere"
    }}>{`Export your content everywhere.`}</h3>
    <p>{`Export renditions of your users' work to a variety of formats.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1060px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "60.37735849056604%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/62d3c222a8dad570107b8b8a4e0319c4/dda86/Explore_Image_4.webp 265w", "/express/add-ons/static/62d3c222a8dad570107b8b8a4e0319c4/010e6/Explore_Image_4.webp 530w", "/express/add-ons/static/62d3c222a8dad570107b8b8a4e0319c4/668f0/Explore_Image_4.webp 1060w", "/express/add-ons/static/62d3c222a8dad570107b8b8a4e0319c4/9ac9d/Explore_Image_4.webp 1160w"],
            "sizes": "(max-width: 1060px) 100vw, 1060px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/62d3c222a8dad570107b8b8a4e0319c4/28773/Explore_Image_4.png 265w", "/express/add-ons/static/62d3c222a8dad570107b8b8a4e0319c4/a0177/Explore_Image_4.png 530w", "/express/add-ons/static/62d3c222a8dad570107b8b8a4e0319c4/ea60f/Explore_Image_4.png 1060w", "/express/add-ons/static/62d3c222a8dad570107b8b8a4e0319c4/9708d/Explore_Image_4.png 1160w"],
            "sizes": "(max-width: 1060px) 100vw, 1060px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/62d3c222a8dad570107b8b8a4e0319c4/ea60f/Explore_Image_4.png",
            "alt": "Illustration showing the ability to export assets to other surfaces from Adobe Express",
            "title": "Illustration showing the ability to export assets to other surfaces from Adobe Express",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.adobe.com/express/add-ons/docs/guides/learn/how_to/create_renditions/"
        }}>{`Learn more`}</a></li>
    </ul>
    <TextBlock slots="image,heading,text,buttons" theme="lightest" headerElementType="h2" variantsTypePrimary='secondary' variantStyleFill="outline" homeZigZag className="explore" position="right" mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1060px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "60.37735849056604%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/e14d409ee93cf72bb15da43235d79432/dda86/Embed_Templates.webp 265w", "/express/add-ons/static/e14d409ee93cf72bb15da43235d79432/010e6/Embed_Templates.webp 530w", "/express/add-ons/static/e14d409ee93cf72bb15da43235d79432/668f0/Embed_Templates.webp 1060w", "/express/add-ons/static/e14d409ee93cf72bb15da43235d79432/89d57/Embed_Templates.webp 1590w", "/express/add-ons/static/e14d409ee93cf72bb15da43235d79432/094b8/Embed_Templates.webp 2120w", "/express/add-ons/static/e14d409ee93cf72bb15da43235d79432/f6c82/Embed_Templates.webp 2320w"],
            "sizes": "(max-width: 1060px) 100vw, 1060px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/e14d409ee93cf72bb15da43235d79432/28773/Embed_Templates.png 265w", "/express/add-ons/static/e14d409ee93cf72bb15da43235d79432/a0177/Embed_Templates.png 530w", "/express/add-ons/static/e14d409ee93cf72bb15da43235d79432/ea60f/Embed_Templates.png 1060w", "/express/add-ons/static/e14d409ee93cf72bb15da43235d79432/684d5/Embed_Templates.png 1590w", "/express/add-ons/static/e14d409ee93cf72bb15da43235d79432/5e85f/Embed_Templates.png 2120w", "/express/add-ons/static/e14d409ee93cf72bb15da43235d79432/d161c/Embed_Templates.png 2320w"],
            "sizes": "(max-width: 1060px) 100vw, 1060px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/e14d409ee93cf72bb15da43235d79432/ea60f/Embed_Templates.png",
            "alt": "Document Authoring API",
            "title": "Document Authoring API",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "transform-adobe-express-user-documents"
    }}>{`Transform Adobe Express user documents`}</h3>
    <p>{`Get deep access to a user’s active document to add rich data visualizations, generate variations from data, and more.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.adobe.com/express/add-ons/docs/guides/learn/how_to/use_text/"
        }}>{`Learn more`}</a></li>
    </ul>
    <TextBlock slots="heading,text" className="announcement exploreCapabilities" theme="light" mdxType="TextBlock" />
    <h3 {...{
      "id": "build-and-share-your-add-on-in-no-time"
    }}>{`Build and share your add-on in no time.`}</h3>
    <p>{`We’ve got a set of libraries and developer tools to make your job even easier.`}</p>
    <WrapperComponent slots="content" repeat="1" theme="light" className="wrapperforCreatorTool" mdxType="WrapperComponent" />
    <DeveloperToolBox mdxType="DeveloperToolBox" />
    <TextBlock slots="heading" className="announcement resourceHeader" theme="lightest" mdxType="TextBlock" />
    <h3 {...{
      "id": "weve-got-your-resources-covered"
    }}>{`We've got your resources covered.`}</h3>
    <MiniResourceCard slots="image,heading,link" repeat="3" theme="lightest" inRow="3" className="mini-card support-tools" mdxType="MiniResourceCard" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "200px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/37aeb0afa851e1f1f1ec4da964599a41/a5e6d/LogoSDK.webp 200w"],
            "sizes": "(max-width: 200px) 100vw, 200px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/37aeb0afa851e1f1f1ec4da964599a41/a6b4f/LogoSDK.jpg 200w"],
            "sizes": "(max-width: 200px) 100vw, 200px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/37aeb0afa851e1f1f1ec4da964599a41/a6b4f/LogoSDK.jpg",
            "alt": "Adobe Express logo over a gradient background",
            "title": "Adobe Express logo over a gradient background",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "blog"
    }}>{`Blog`}</h3>
    <p><a parentName="p" {...{
        "href": "https://adobe.ly/expressaddons"
      }}>{`Link to blog post`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "200px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/b8725f64fad2e0a4b354b81cfa77ea5a/a5e6d/code.webp 200w"],
            "sizes": "(max-width: 200px) 100vw, 200px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/b8725f64fad2e0a4b354b81cfa77ea5a/a6b4f/code.jpg 200w"],
            "sizes": "(max-width: 200px) 100vw, 200px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/b8725f64fad2e0a4b354b81cfa77ea5a/a6b4f/code.jpg",
            "alt": "Icon showing a code block",
            "title": "Icon showing a code block",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "code-samples"
    }}>{`Code samples`}</h3>
    <p><a parentName="p" {...{
        "href": "https://developer.adobe.com/express/add-ons/docs/guides/learn/samples/"
      }}>{`Link to code samples`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "200px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/ded7e45e2199ad8438fbc153ed041398/a5e6d/change_log.webp 200w"],
            "sizes": "(max-width: 200px) 100vw, 200px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/ded7e45e2199ad8438fbc153ed041398/a6b4f/change_log.jpg 200w"],
            "sizes": "(max-width: 200px) 100vw, 200px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/ded7e45e2199ad8438fbc153ed041398/a6b4f/change_log.jpg",
            "alt": "Icon showing a changelog",
            "title": "Icon showing a changelog",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "changelog"
    }}>{`Changelog`}</h3>
    <p><a parentName="p" {...{
        "href": "https://developer.adobe.com/express/add-ons/docs/guides/getting_started/changelog/"
      }}>{`Link to changelog`}</a></p>
    <TeaserBlock slots="heading,text,buttons" textColor="white" bgURL={bgImg} className="viewAddOn" variant="fullwidth" mdxType="TeaserBlock" />
    <p className="teaserBlockCustomHeading">Apply to the Adobe Fund for Design</p>
    <p>{`Get funding to build Adobe Express add-ons.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.adobe.com/fund-for-design"
        }}>{`Apply now`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      